import { Col, Container, Row, Table } from "reactstrap";
import React from "react";
import { JedaiCalendarioViewText } from "../../../coms/BlkCalendario";

export const Garantias = ({ garantias }) => {
    return (
        <Container className="text-center">
            <Row>
                <Col className={"table-responsive col-lg-12"}>
                    <React.Fragment>
                        <Table className="adjusttd text-center">
                            <thead className="text-primary">
                                <tr>
                                    <th>Item</th>
                                    <th>Descripción</th>
                                    <th>Fc Efec Cump</th>
                                    <th>Fc Max Cond</th>
                                    <th>Observaciones</th>
                                    <th>Activo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {garantias.length === 0 ? (
                                    <React.Fragment>
                                        <tr>
                                            <td colSpan={4}>
                                                <span>No hay información disponible.</span>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {garantias.map((item, index) => (
                                            <tr key={item.cdDeducible}>
                                                <td>
                                                    <span>{index + 1}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 220 }}>
                                                    <span>{item.nmGarantia}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <JedaiCalendarioViewText value={item.fcEfecCumplimiento} />
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <JedaiCalendarioViewText value={item.fcMaxCondicionada} />
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>{item.obsGarantiaNegocio}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>{item.activo ? "SI" : "NO"}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                )}
                            </tbody>
                        </Table>
                    </React.Fragment>
                </Col>
            </Row>
        </Container>
    );
};
